import { Box, Typography } from '@mui/material';
import {
  VideoTile,
  useActiveSpeakersState,
  useAttendeeStatus,
  useRosterState,
} from 'amazon-chime-sdk-component-library-react';
import { useMemo } from 'react';

const CustomVideoTile = ({ attendeeId }) => {
  const { videoEnabled } = useAttendeeStatus(attendeeId);
  const { roster } = useRosterState();
  const { activeSpeakers } = useActiveSpeakersState();
  const attendee = roster[attendeeId];

  const isSpeaking = useMemo(() => activeSpeakers && activeSpeakers.includes(attendeeId), [activeSpeakers]);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%', // Adjust the width as needed
        height: 'auto', // Allow height to be automatically adjusted or set a fixed value
        aspectRatio: '16/9', // Maintain 16:9 aspect ratio
        backgroundColor: '#333',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: isSpeaking ? '3px solid green' : '1px solid #ccc',
        overflow: 'hidden', // Ensure content stays within bounds
      }}
    >
      {videoEnabled ? (
        // Render the video tile
        <Box sx={{ width: '100%', height: '100%' }}>
          <VideoTile attendeeId={attendeeId} />
        </Box>
      ) : (
        // Show attendee's name
        <Typography variant="h6" color="white">
          { 'Unknown User'}
        </Typography>
      )}
    </Box>
  );
};

export default CustomVideoTile;
